import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import { sequence, parallel } from "slotworks/utils/race-utils";
import * as TweenJS from "slotworks/utils/tween";
import currency from "slotworks/i18n/currency";

export default class JackpotComponent {

    public static COUNT_TIME = 15000;
    public static WAIT_TIME = 1000;

    public static SCALE = 1.2;

    private complete: boolean;
    private valueText: PIXI.extras.BitmapText;
    private pot: boolean;

    constructor() {

    }

    public show(amount: number, pot: boolean = false): Contract<void> {
        this.complete = false;
        this.pot = pot;
        return sequence([
            () => new Contract<void>(resolve => {
                Layers.CelebrationBackground.setScene("jackpot").execute();
                Layers.CelebrationForeground.setScene("jackpot").then(() => {
                    this.valueText = Layers.CelebrationForeground.getBitmapText("value");
                    this.valueText.text = "";
                });
                Layers.CelebrationContent.setScene("jackpot_intro").then(() => {
                    const intro = Layers.CelebrationContent.getAnimatedSprite("jackpot_title_intro");
                    intro.anchor.set(0.5, 0.5);
                    intro.x += intro.width / 2;
                    intro.y += intro.height / 2
                    intro.scale.set(JackpotComponent.SCALE, JackpotComponent.SCALE);
                    intro.onComplete = () => resolve(null);
                    intro.gotoAndPlay(0);
                    intro.visible = true;
                    this.startTween(amount);
                });
            }),
            () => new Contract<void>(resolve => {
                Layers.CelebrationContent.setScene("jackpot_loop").then(() => {
                    const loopAnim = Layers.CelebrationContent.getAnimatedSprite("jackpot_title_loop");
                    loopAnim.anchor.set(0.5, 0.5);
                    loopAnim.x += loopAnim.width / 2;
                    loopAnim.y += loopAnim.height / 2;
                    loopAnim.scale.set(JackpotComponent.SCALE, JackpotComponent.SCALE);
                    loopAnim.loop = true;
                    loopAnim.onComplete = () => {
                        if (this.complete) {
                            loopAnim.stop();
                            resolve(null);
                        }
                    };
                    loopAnim.gotoAndPlay(0);
                });
            }),
            () => new Contract<void>(resolve => {
                Layers.CelebrationContent.setScene("jackpot_end").then(() => {
                    const endAnim = Layers.CelebrationContent.getAnimatedSprite("jackpot_title_end");
                    endAnim.anchor.set(0.5, 0.5);
                    endAnim.x += endAnim.width / 2;
                    endAnim.y += endAnim.height / 2;
                    endAnim.scale.set(JackpotComponent.SCALE, JackpotComponent.SCALE);
                    endAnim.onComplete = () => resolve(null);
                });
            }),
            () => new Contract<void>(resolve => {
                Layers.CelebrationContent.setScene("jackpot").then(() => {
                    const title = Layers.CelebrationContent.getSprite("jackpot_title");
                    title.anchor.set(0.5, 0.5);
                    title.x += title.width / 2;
                    title.y += title.height / 2;
                    title.scale.set(JackpotComponent.SCALE, JackpotComponent.SCALE);
                    setTimeout(() => {
                        Layers.Custom.get("JackpotRuby").setScene("default").execute();
                        Layers.CelebrationContent.defaultScene().then(() => {
                            parallel([
                                () => Layers.CelebrationForeground.defaultScene(),
                                () => Layers.CelebrationBackground.defaultScene()
                            ]).then(() => {
                                resolve(null);
                            });
                        });
                    }, JackpotComponent.WAIT_TIME);
                });
            })
        ]);
    }

    private startTween(amount: number) {
        const obj = { value: 0 };
        let tween = new TweenJS.Tween(obj)
            .to({ value: amount }, JackpotComponent.COUNT_TIME);

        tween.onComplete(() => {
            this.valueText.text = currency.format(obj.value, undefined, undefined, true);
            this.complete = true;
        });
        tween.onUpdate(() => {
            this.valueText.text = currency.format(obj.value, undefined, undefined, true, true);
        }).start();
    }

}